import { Avatar } from 'antd';
import { useState } from 'react';

interface CustomAvatarProps {
  src?: string;
  alt?: string;
  size?: number;
}

const DEFAULT_AVATAR = '/static/media/logo.cdf96f84.png';

const CustomAvatar: React.FC<CustomAvatarProps> = ({ src, alt, size }) => {
  const [imageSrc, setImageSrc] = useState(src || DEFAULT_AVATAR);

  return (
    <Avatar
      shape="circle"
      size={size}
      src={imageSrc}
      alt={alt}
      onError={() => {
        setImageSrc(DEFAULT_AVATAR);
        return false;
      }}
    />
  );
};

export default CustomAvatar;
